import { formatDistanceToNow } from 'date-fns';
import { de } from 'date-fns/locale';

export const makeDatesRelative = () => {
  const dateElements = document.querySelectorAll('.js-relative-date');

  const dates = Array.from(dateElements);
  dates.forEach(date => {
    const dateAttr = date.getAttribute('datetime');
    if (!dateAttr) return;

    const datetime = new Date(dateAttr);
    if (datetime.toString() === 'Invalid Date') return;

    const formatted = formatDistanceToNow(datetime, {
      addSuffix: true,
      locale: de,
    });

    date.textContent = formatted;
  });
};
